<template>
    <div class="center-dropdown-holder app-dropdown-holder">
        <div class="center-dropdown">
            <div
                class="center-dropdown-selected pointer app-dropdown-selected"
                @click="appDropDownShow = !appDropDownShow"
            >
                <span v-if="app == 'sales'" class="app-dropdown-item-sales"
                    >Sälj</span
                >
                <span v-if="app == 'clp'" class="app-dropdown-item-clp"
                    >CLP</span
                >

                <i
                    :class="appDropDownShow ? 'dropdown-arrow-open' : ''"
                    class="material-icons icon-rock pointer dropdown-arrow"
                    >arrow_drop_down</i
                >
            </div>
        </div>

        <div
            class="center-dropdown-items scroll-bar-no-padding app-dropdown-items"
            v-if="appDropDownShow"
        >
            <ul>
                <li
                    :class="[
                        app == 'sales' ? 'center-dropdown-item-selected' : '',
                    ]"
                    @click="loadSales()"
                >
                    <div>Sälj</div>
                </li>
                <li
                    :class="[
                        app == 'clp' ? 'center-dropdown-item-selected' : '',
                    ]"
                    @click="loadCLP()"
                >
                    <div>CLP</div>
                </li>
            </ul>
        </div>
    </div>
    <Loading :loading="loading" />
</template>

<script>
import "vue3-toastify/dist/index.css";
import { mapStores } from "pinia";
import { useAuthStore } from "../stores/auth.js";

export default {
    computed: {
        ...mapStores(useAuthStore),
    },
    props: ["app"],
    emits: ["centerSelected"],
    data() {
        return {
            loading: false,
            appDropDownShow: false,
        };
    },
    methods: {
        loadSales() {
            this.loading = true;
            window.location.href = "/app/sales";
        },
        loadCLP() {
            this.loading = true;
            window.location.href = "/app/clp";
        },
    },
};
</script>

<style>
.app-dropdown-holder {
    display: none;

    width: 130px;
    margin-right: 30px;

    @media (min-width: 1070px) {
        display: block;
    }
}

.app-dropdown-selected {
    padding-left: 16px;
}

.app-dropdown-items li {
    cursor: pointer;
}

.app-dropdown-items li div {
    padding: 0 20px;
    font-weight: 700;
    font-family: "hansen-grotesque-bold", sans-serif;
}

.app-dropdown-item-sales {
    color: #f0957f;
}

.app-dropdown-item-clp {
    color: #617594;
}
</style>
